/**
 * Longevity 360 node L2: `specimen.collection_recorded`.
 *
 * Fired by the lab desk after a "Mark as Sample Collected" save succeeded.
 * Fire-and-forget: the save never waits on it and never fails because of it.
 * `postL360Event` never throws; this sender is a no-op unless VITE_L360_EVENTS is on.
 */
import { isL360EventsEnabled, postL360Event } from '@/shared/services/l360-events';

export interface CollectionRecordedInput {
  patientId: string;
  labRequestId: string;
  /** Set for a split part (the order's part at another lab). */
  requisitionId?: string | null;
  collectorId: string;
}

export const SPECIMEN_COLLECTION_RECORDED = 'specimen.collection_recorded';

export function postCollectionRecorded(input: CollectionRecordedInput): void {
  if (!isL360EventsEnabled()) return;
  const { patientId, labRequestId, collectorId } = input;
  const requisitionId = input.requisitionId || undefined;
  const occurredAt = new Date().toISOString();
  const sourceRef = requisitionId
    ? `${labRequestId}:${requisitionId}`
    : labRequestId;
  // Stable key, no client clock: one collection effect per order or part. A double
  // click or a second tab sends the same key and the engine absorbs the repeat.
  void postL360Event({
    eventType: SPECIMEN_COLLECTION_RECORDED,
    patientId,
    sourceRef,
    idempotencyKey: `${SPECIMEN_COLLECTION_RECORDED}:${sourceRef}`,
    occurredAt,
    payload: {
      orderIds: [labRequestId],
      specimenId: requisitionId ?? labRequestId,
      collectorId,
    },
  });
}
